import { useCallback, useEffect, useMemo } from "react";
import Form from "rc-field-form";
import { useTranslation } from "react-i18next";
import { Card, CardHeader, Col, Row } from "reactstrap";
import Button from "../../../../../components/Button";
import Content from "./Content";
import { useConfigurationModule } from "../../hooks/useConfigurationModule";
import { useConfigurationActions } from "../../api/useConfiguration";
import { useConfig } from "./Content/config";

const options = [
    "job-information",
    "personal-information",
    "company-information",
    "hiring-information",
    "address",
    "key-dates",
    "organization",
    "status",
    "expected-hours",
    "employment-type",
    "terminate",
    "custom-fields",
];

function People() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const fieldsConfig = useConfig();
    const config = useConfigurationModule("peopleApiConnection");
    const { submit, submitting } = useConfigurationActions("peopleApiConnection");

    const onFinish = useCallback(async (formValues) => {
        try {
            await submit({
                entity: "company",
                config: formValues,
            });
        } catch (err) { }
    }, [submit]);

    const formValues = useMemo(() => {
        const merged = {};

        Object.entries(fieldsConfig).forEach(([section, items]) => {
            merged[section] = {};
            items.forEach((item) => {
                // If config has value, use it; otherwise false
                merged[section][item.key] = config?.[section]?.[item.key] ?? false;
            });
        });

        return merged;
    }, [fieldsConfig, config]);

    useEffect(() => {
        form.setFieldsValue(formValues);
    }, [form, formValues]);


    return (
        <div className="d-flex h-100 configuration">
            <Card className="flex-fill mb-0 h-100">
                <Form form={form} onFinish={onFinish} style={{ height: "calc(100% - 160px)" }}>
                    <CardHeader>
                        <Row>
                            <Col xs="6" className="pl-4 d-flex">
                                <h3 className="mb-0 mr-5">{t("people")}</h3>
                            </Col>

                            <Col className="text-right" xs="6">
                                <Button
                                    className="btn-dark px-3 btn-round btn-icon"
                                    size="sm"
                                    loading={submitting}
                                    type="submit"
                                >
                                    {t("save")}
                                </Button>
                            </Col>
                        </Row>
                    </CardHeader>

                    <div
                        className="w-100 d-flex gap-x-20 flex-wrap scroll p-4"
                        style={{ overflow: "auto", maxHeight: "100%" }}
                    >
                        {options.map((option) => (
                            <Content option={option} />
                        ))}
                    </div>
                </Form>
            </Card>
        </div>
    );
}

export default People;
